import { NotificationContainer, NotificationStyledIcon } from './styles';

/**
 * @param {Object} param
 * @param {string | undefined} [param.error ]
 * @param {string | undefined} [param.success]
 * @param {string | undefined} [param.position='relative']
 * @returns {React.ReactElement}
 */
const Notification = ({ error, success, position = 'relative' }) => {
  const message = success || error;
  return (
    <NotificationContainer
      position={position}
      type={success ? 'SUCCESS' : 'ERROR'}
    >
      {message && (
        <div className="notification-wrapper">
          {position === 'relative' && <div className="notification-arrow" />}
          <div className="notification-content">
            {message}{' '}
            <NotificationStyledIcon icon={success ? 'CHECK' : 'EXCLAMATION'} />
          </div>
        </div>
      )}
    </NotificationContainer>
  );
};

export default Notification;
